<template>
	<div class="modal fade" id="modalPromemoriaTask" tabindex="-1" aria-labelledby="modalPromemoriaTaskLabel"
		aria-hidden="true">
		<div class="modal-dialog">
			<div class="modal-content rounded-3">
				<div class="modal-header">
					<h5 class="modal-title" id="modalPromemoriaTaskLabel">Impostazioni Promemoria</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Chiudi"></button>
				</div>
				<div class="modal-body">
					<div class="mb-3">
						<label class="form-label">Data e ora promemoria</label>
						<input type="datetime-local" class="form-control" v-model="promemoria.DATA_PROMEMORIA">
					</div>

					<div class="mb-3">
						<label class="form-label">Minuti prima della scadenza</label>
						<input type="number" min="0" class="form-control" v-model="promemoria.MINUTI_PRIMA">
					</div>

					<div class="form-check form-switch mb-3">
						<input class="form-check-input" type="checkbox" v-model="promemoria.RICORRENTE"
							id="ricorrenteCheck">
						<label class="form-check-label" for="ricorrenteCheck">Ricorrente</label>
					</div>

					<div class="mb-3">
						<label class="form-label">Ripeti dopo (minuti)</label>
						<input type="number" min="0" class="form-control" v-model="promemoria.RIPETI_DOPO"
							:disabled="!promemoria.RICORRENTE">
					</div>

				</div>

				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
					<button v-if="promemoria.FK_ID_NOTIFICA > 0" type="button" class="btn btn-danger"
						@click="eliminaPromemoria">
						Elimina promemoria
					</button>
					<button type="button" class="btn btn-primary" @click="salvaPromemoria">
						Salva promemoria
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PromemoriaForm',
	props: {
		utente: Object,
		task: Object,
		valore: Object
	},
	data() {
		return {
			promemoria: {},
			filters: global.filters,
		};
	},
	watch: {
		valore: {
			immediate: true,
			handler(nuovo) {
				this.promemoria = { ...nuovo };
			}
		}
	},
	methods: {
		openPromemoria(task){
			if (task.PROMEMORIA == 1) {
				this.modificaPromemoria(task);
			} else {
				this.aggiungiPromemoria(task);
			}
		},
		salvaPromemoria() {
			if (!this.promemoria.DATA_PROMEMORIA) {
				utils.alert.warning("Specifica una data e ora per il promemoria.");
				return;
			}
			if (this.promemoria.RICORRENTE && !this.promemoria.RIPETI_DOPO) {
				utils.alert.warning("Specifica ogni quanti minuti ripetere il promemoria ricorrente.");
				return;
			}

			const payload = {
				FK_ID_NOTIFICA: this.promemoria.FK_ID_NOTIFICA,
				FK_ID_TIPOLOGIA: 7,
				DESCRIZIONE: 'Promemoria per task',
				FK_ID_TASK: this.promemoria.FK_ID_TASK,
				FK_ID_MODULO: this.promemoria.FK_ID_MODULO,
				FK_ID_UTENTE: this.promemoria.FK_ID_UTENTE,
				FK_ID_UTENTE_CREATORE: this.promemoria.FK_ID_UTENTE_CREATORE,
				UTENTI: this.promemoria.UTENTI,
				DATA_PROMEMORIA: this.promemoria.DATA_PROMEMORIA,
				MINUTI_PRIMA: this.promemoria.MINUTI_PRIMA || 0,
				RIPETI_DOPO: this.promemoria.RICORRENTE ? this.promemoria.RIPETI_DOPO : 0,
				RICORRENTE: this.promemoria.RICORRENTE ? 1 : 0
			};

			const endpoint = this.promemoria.FK_ID_NOTIFICA
				? 'core/task/modifyReminder'
				: 'core/task/createReminder';

			utils.ajax(endpoint, payload, (response) => {
				if (response.esito == 0) {
					utils.alert.success("Promemoria " + (this.promemoria.FK_ID_NOTIFICA ? "modificato" : "creato") + " con successo.");
					this.filters.closePopUp('modalPromemoriaTask');
					this.$emit('salvato');
				} else {
					utils.alert.danger("Errore: " + response.messaggio);
				}
			});
		},
		aggiungiPromemoria(task) {
			this.promemoria = {
				FK_ID_TASK: task.ID_TASK,
				DATA_PROMEMORIA: '',
				MINUTI_PRIMA: 15,
				RIPETI_DOPO: null,
				RICORRENTE: false,
				FK_ID_TIPOLOGIA: 7,
				FK_ID_MODULO: 23,  
				FK_ID_UTENTE: this.$root.utente.ID_UTENTE,                    
				FK_ID_UTENTE_CREATORE: this.$root.utente.ID_UTENTE,           
				UTENTI: [this.$root.utente.ID_UTENTE]                          
			};
			this.filters.openPopUp('modalPromemoriaTask');
		},
		modificaPromemoria(task) {
			const payload = { FK_ID_TASK: task.ID_TASK, ID_UTENTE: this.$root.utente.ID_UTENTE };
			utils.ajax('core/task/getRemindersByTask', payload, (response) => {
				if (response.data && response.data.promemoria) {
					this.promemoria = {
						...response.data.promemoria[0],
						FK_ID_UTENTE: this.$root.utente.ID_UTENTE,
						FK_ID_TASK: task.ID_TASK,
						FK_ID_UTENTE_CREATORE: this.$root.utente.ID_UTENTE,
						UTENTI: [this.$root.utente.ID_UTENTE]
					};
					this.filters.openPopUp('modalPromemoriaTask');
				} else {
					this.utils.alert.warning("Nessun promemoria trovato per questa task.");
				}
			});
		},
		eliminaPromemoria() {
			if (!this.promemoria.FK_ID_NOTIFICA) {
				utils.alert.warning("Nessun promemoria da eliminare.");
				return;
			}
			utils.ajax('core/task/deleteReminder', { FK_ID_NOTIFICA: this.promemoria.FK_ID_NOTIFICA }, (response) => {
				if (response.esito == 0) {
					utils.alert.success("Promemoria eliminato con successo.");
					this.filters.closePopUp('modalPromemoriaTask');
					this.$emit('eliminato');
				} else {
					utils.alert.danger("Errore: " + response.messaggio);
				}
			});
		},
	}
};
</script>
